import { useSnackbar } from 'notistack'
import { useContext, useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { WorkspaceFormContext } from 'features/workspace/contexts/WorkspaceFormContext'
import { mapGraphQLErrors } from 'providers/graphql'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { EditSchema } from '../../schemas/edit'
import { UPDATE_WORKSPACE } from './api/mutation'
import { Data, Variables } from './api/types'
import { mapper } from './mapper'
import { UseUpdateWorkspace } from './types'

export const useUpdateWorkspace = (): UseUpdateWorkspace => {
  const { t } = useTranslation('features/workspace')
  const { enqueueSnackbar } = useSnackbar()
  const { setLoading } = useContext(WorkspaceFormContext)
  const [errors, setErrors] = useState<FieldErrors<EditSchema>>({})

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_WORKSPACE,
    onCompleted: async data => {
      const {
        updateWorkspace: { errors, workspace },
      } = data

      setLoading(false)

      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('form.error.update'), { variant: 'error' })
      } else if (workspace) {
        setErrors({})
        enqueueSnackbar(t('form.success.update'), { variant: 'success' })
      }
    },
  })

  const update = (data: EditSchema) => {
    setLoading(true)

    return mutateAsync({
      input: mapper(data),
    })
  }

  return { errors, update }
}
